import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { NavLink as RouterLink } from 'react-router-dom';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import EmailIcon from '@mui/icons-material/Email';
import {
    Avatar, Box, Card,
    CardContent, Divider, Grid,
    Typography, CardHeader,
    IconButton, Menu, MenuItem
} from '@mui/material';

import stringRedutor from 'modules/utils/stringRedutor';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
		height: '100%',
    },
    statsItem: {
        alignItems: 'center',
        display: 'flex'
    },
    statsIcon: {
        marginRight: theme.spacing(1)
    }
}));

function UserCard({ className, user, updateStatusUser, deleteUser, setUserDelete, ...rest }) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    function handleClick(currentTarget) {
        setAnchorEl(currentTarget);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    return (
        <Card className={clsx(classes.root, className)} {...rest}>
            <CardHeader
                title={stringRedutor(user.name, 25)}
                action={
                    <Box>
                        <IconButton
                            aria-label="edit"
                            component={RouterLink}
                            to={`/usuarios/editar/${user.idUser}`}
                        >
                            <CreateIcon />
                        </IconButton>
                       {/*  {user.userIsActive && (
                            <IconButton aria-label="settings" onClick={(e) => setUserDelete({idUser: user.idUser, active: true})} >
                                <DeleteIcon />
                            </IconButton>
                        )} */}
                        <IconButton aria-label="settings" onClick={(e) => handleClick(e.currentTarget)} >
                            <MoreVertIcon />
                        </IconButton>
                        
                        <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                        >
                            <MenuItem onClick={(e) => {
                                updateStatusUser(user.idUser)
                                handleClick(e.currentTarget)
                            }}>
                                {user.userIsActive ? "Desativar usuário" : "Ativar usuário"}
                            </MenuItem>
                        </Menu>
                    </Box>
                }
            />
            <Box flexGrow={1} />
            <Divider />
            <CardContent>
                <Box
                    display="flex"
                    justifyContent="center"
                >
                    <Avatar
                        alt="User"
                        src={user.avatarUrl}
                        variant="square"
                    />
                </Box>
            </CardContent>
            <Box flexGrow={1} />
            <Divider />
            <Box p={2}>
                <Grid
                    container
                    justifyContent="space-between"
                    spacing={2}
                >
                    <Grid
                        className={classes.statsItem}
                        item
                    >
                        <EmailIcon
                            className={classes.statsIcon}
                            color="action"
                        />
                        <Typography
                            color="textSecondary"
                            display="inline"
                            variant="body2"
                        >
                            {stringRedutor(user.email, 25)}
                        </Typography>
                    </Grid>

                    <Grid
                        className={classes.statsItem}
                        item
                    >
                        <FiberManualRecordIcon
                            className={classes.statsIcon}
                            sx={{ color: user.userIsActive ? 'green' : 'red' }}
                        />
                        <Typography
                            color="textSecondary"
                            display="inline"
                            variant="body2"
                        >
                            {user.userIsActive ? 'Ativo' : 'Inativo'}
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
        </Card>
    );
}

UserCard.propTypes = {
    className: PropTypes.string,
    user: PropTypes.object.isRequired,
    updateStatusUser: PropTypes.func.isRequired,
    deleteUser: PropTypes.func.isRequired,
    setUserDelete: PropTypes.func.isRequired,
};

export default UserCard;